import { PeopleList } from "./PeopleList";
import { PeopleMap } from "./PeopleMap";

type PeopleCompound = {
  List: typeof PeopleList;
  Map: typeof PeopleMap;
};

export const People: PeopleCompound = {
  List: PeopleList,
  Map: PeopleMap,
};
